import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";

export class SupabaseMomentExportService extends SupabaseServiceView<"export_moment"> {
  table = "export_moment" as const;
}
